import React from "react";
import Bugsnag from "@bugsnag/js";

import {ShareIcon} from "@pg-design/icons-module";

import {SocialShare} from "../../../../app/components/SocialShare";
import {reelsAnalytics} from "../../../tracking/reels_gtm_events";
import {ReelDetailsActionButton} from "./ReelDetailsActionButton";

interface IProps {
    reelId: number;
    title: string;
    creatorName: string;
    url: string;
    shareDropdownWidth?: string;
}

export const ReelDetailsShareButton = (props: IProps) => {
    const handleErrorMessage = (error: Error) => {
        Bugsnag.notify(error);
    };

    const hitAnalytics = () => {
        reelsAnalytics.gtm.reelShareEvent({reels_name: props.title, reels_developer: props.creatorName, reels_id: props.reelId});
    };

    return (
        <SocialShare
            shareDropdownWidth={props.shareDropdownWidth}
            url={props.url}
            title={props.title}
            onError={handleErrorMessage}
            onTracking={hitAnalytics}
            disableNativeShare
        >
            <ReelDetailsActionButton icon={ShareIcon} />
        </SocialShare>
    );
};
import React from "react";
import Bugsnag from "@bugsnag/js";

import {ShareIcon} from "@pg-design/icons-module";

import {SocialShare} from "../../../../app/components/SocialShare";
import {reelsAnalytics} from "../../../tracking/reels_gtm_events";
import {ReelDetailsActionButton} from "./ReelDetailsActionButton";

interface IProps {
    reelId: number;
    title: string;
    creatorName: string;
    url: string;
    shareDropdownWidth?: string;
}

export const ReelDetailsShareButton = (props: IProps) => {
    const handleErrorMessage = (error: Error) => {
        Bugsnag.notify(error);
    };

    const hitAnalytics = () => {
        reelsAnalytics.gtm.reelShareEvent({reels_name: props.title, reels_developer: props.creatorName, reels_id: props.reelId});
    };

    return (
        <SocialShare
            shareDropdownWidth={props.shareDropdownWidth}
            url={props.url}
            title={props.title}
            onError={handleErrorMessage}
            onTracking={hitAnalytics}
            disableNativeShare
        >
            <ReelDetailsActionButton icon={ShareIcon} />
        </SocialShare>
    );
};
